import TiposDeAtendimentoPage from "@/Pages/DiarioAtendimentos/TiposDeAtendimento/index.vue";
import DiarioAtendimentosEmBrevePage from "@/Pages/DiarioAtendimentos/EmBrevePage.vue";
import AtendimentosIndexPage from "@/Pages/DiarioAtendimentos/Atendimentos/index.vue";
import NewEditAtendimentoPage from "@/Pages/DiarioAtendimentos/Atendimentos/NewEditAtendimentoPage.vue";
import DesenvolvimentoBibliotecaPage from "@/Pages/DiarioAtendimentos/DesenvolvimentoBiblioteca/index.vue";
import FeedbackCoordenacaoPage from "@/Pages/DiarioAtendimentos/FeedbackCoordenacao/index.vue";
import { can } from "@/plugins/can";

function exigirPermissao(permissoes) {
  return (to, from, next) => {
    if (!can(permissoes)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
}

export default [
  {
    path: "/diario-atendimentos/tipos",
    name: "diarioAtendimentos.tipos",
    component: TiposDeAtendimentoPage,
    beforeEnter: exigirPermissao(["tiposAtendimento.listar", "tiposAtendimento.*"]),
  },
  {
    path: "/diario-atendimentos",
    name: "diarioAtendimentos",
    component: AtendimentosIndexPage,
    beforeEnter: exigirPermissao(["atendimentos.listar", "atendimentos.*"]),
  },
  {
    path: "/diario-atendimentos/atendimentos",
    name: "diarioAtendimentos.atendimentos",
    component: AtendimentosIndexPage,
    beforeEnter: exigirPermissao(["atendimentos.listar", "atendimentos.*"]),
  },
  {
    path: "/diario-atendimentos/atendimentos/criar",
    name: "diarioAtendimentos.atendimentos.create",
    component: NewEditAtendimentoPage,
    props: { editing: false },
    beforeEnter: exigirPermissao(["atendimentos.criar", "atendimentos.*"]),
  },
  {
    path: "/diario-atendimentos/atendimentos/editar/:atendimento_id",
    name: "diarioAtendimentos.atendimentos.edit",
    component: NewEditAtendimentoPage,
    props: { editing: true },
    beforeEnter: exigirPermissao(["atendimentos.editar", "atendimentos.*"]),
  },
  {
    path: "/diario-atendimentos/desenvolvimento-biblioteca",
    name: "diarioAtendimentos.biblioteca",
    component: DesenvolvimentoBibliotecaPage,
    beforeEnter: exigirPermissao([
      "desenvolvimentoBiblioteca.listar",
      "desenvolvimentoBiblioteca.*",
    ]),
  },
  {
    path: "/diario-atendimentos/desenvolvimento-recomposicao",
    name: "diarioAtendimentos.recomposicao",
    component: DiarioAtendimentosEmBrevePage,
    props: { titulo: "Desenvolvimento Recomposição" },
    beforeEnter: exigirPermissao([
      "desenvolvimentoRecomposicao.listar",
      "desenvolvimentoRecomposicao.*",
    ]),
  },
  {
    path: "/diario-atendimentos/feedback-coordenacao",
    name: "diarioAtendimentos.feedback",
    component: FeedbackCoordenacaoPage,
    beforeEnter: exigirPermissao([
      "feedbackCoordenacao.listar",
      "feedbackCoordenacao.visualizar",
      "feedbackCoordenacao.*",
    ]),
  },
];
